import {StateCreator} from "zustand/vanilla";
import {
  CreateSecretRequest,
  CreateSecretResponse,
  DeleteSecretRequest,
  ListSecretsResponse,
  UpdateSecretValueRequest,
  UpdateSecretValueResponse,
} from "@/pb/api/devplan/services/web/company";
import {companySecretsAPI} from "@/app/apiPaths";
import {jr} from "@/hooks/queries/response-handler";
import {SecretMetadata} from "@devplaninc/codeup";

export type SecretsStoreState = {
  secrets: Record<string, SecretMetadata>;
  fetchSecrets(companyId: number): Promise<void>;
  createSecret(companyId: number, name: string, value: string): Promise<void>;
  updateSecretValue(companyId: number, secretId: string, value: string): Promise<void>;
  deleteSecret(companyId: number, secretId: string): Promise<void>;
}

export const createSecretsSlice: StateCreator<
  SecretsStoreState,
  [],
  [],
  SecretsStoreState
> = ((set) => ({
  secrets: {},
  fetchSecrets: async (companyId) => fetch(companySecretsAPI(companyId))
    .then(jr)
    .then((js) => {
      const resp = ListSecretsResponse.fromJSON(js);
      const secrets = resp.secrets
        .map(s => SecretMetadata.fromJSON(JSON.parse(s.metadataJson)))
        .reduce((acc, curr) => ({...acc, [curr.id]: curr}), {} as Record<string, SecretMetadata>)
      set((s) => ({
        ...s,
        secrets: {...s.secrets, ...secrets},
      }));
    }),
  createSecret: async (companyId, name, value) => fetch(companySecretsAPI(companyId), {
    method: "POST",
    body: JSON.stringify(CreateSecretRequest.toJSON({name, value})),
  }).then(jr).then(js => {
    const resp = CreateSecretResponse.fromJSON(js);
    const secret = SecretMetadata.fromJSON(JSON.parse(resp.secret!.metadataJson));
    set(s => ({...s, secrets: {...s.secrets, [secret.id]: secret}}))
  }),
  updateSecretValue: async (companyId, secretId, value) => fetch(companySecretsAPI(companyId), {
    method: "PUT",
    body: JSON.stringify(UpdateSecretValueRequest.toJSON({secretId, value})),
  }).then(jr).then(js => {
    const resp = UpdateSecretValueResponse.fromJSON(js);
    const secret = SecretMetadata.fromJSON(JSON.parse(resp.secret!.metadataJson));
    set(s => ({...s, secrets: {...s.secrets, [secret.id]: secret}}))
  }),
  deleteSecret: async (companyId, secretId) => fetch(companySecretsAPI(companyId), {
    method: "DELETE",
    body: JSON.stringify(DeleteSecretRequest.toJSON({secretId})),
  }).then(jr).then(() => {
    set((s) => {
      const {[secretId]: deleted, ...secrets} = s.secrets
      return {...s, secrets};
    });
  }),
}));
